<template>
  <div class="app-container">
    <div class="wt-form-inputs-container">
      <div class="wt-form-inputs-content">
        <el-form size="small" :inline="true" class="wt-form-inputs">
          <el-form-item label="时间：">
            <el-date-picker v-model="form.dataTimeRange"
              type="datetimerange" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']" :unlink-panels="true">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="站点：">
            <el-cascader
              class="search-ascader"
              v-model="form.siteIdList"
                :options="siteOptions"
                :props="props"
                 placeholder="请选择"
                 filterable
                 collapse-tags
                clearable></el-cascader>
          </el-form-item>
          <!-- <el-form-item label="社区：">
            <el-select v-model="form.communityId" filterable placeholder="请选择" @change="communityIdChange">
                <el-option
                  v-for="item in communityOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="站点：">
            <el-select v-model="form.siteId" filterable placeholder="请选择">
                <el-option
                  v-for="item in siteOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
            </el-select>
          </el-form-item> -->
          <el-button size="small" type="primary" @click="toClickAction('search')">查询</el-button>
          <el-button size="small"  @click="toClickAction('reset')">重置</el-button>
        </el-form>
      </div>
    </div>
    <div class="chart-container">
      <div class="chart-item">
        <div class="chart-item-tit">可回收物投递出库图</div>
        <wt-auth class="search-form-btn" :hasAnyPremission="'MODULE_SITESTATISTICS:EXPORT'">
          <el-button class="chart-export chart-export-total" size="small" @click="exportChart('可回收物投递统计合计', recyclingTotalUrl)">导出合计</el-button>
          <el-button class="chart-export" size="small" @click="exportChart('可回收物投递统计', recyclingUrl)">导出</el-button>
        </wt-auth>
        <div class="chart-item-canvas" id="sasRecyclingChart"></div>
      </div>
      <div class="chart-item">
        <div class="chart-item-tit">其他类型统计图</div>
        <wt-auth class="search-form-btn" :hasAnyPremission="'MODULE_SITESTATISTICS:EXPORT'">
          <el-button class="chart-export chart-export-total" size="small" @click="exportChart('其他类型统计合计', otherTotalUrl)">导出合计</el-button>
          <el-button class="chart-export" size="small" @click="exportChart('其他类型统计', otherUrl)">导出</el-button>
        </wt-auth>
        <div class="chart-item-canvas" id="sasSHApplianceChart"></div>
      </div>
<!--      <div class="chart-item">
        <div class="chart-item-tit">耗材统计图</div>
        <div class="chart-item-canvas" id="sasConsumablesChart"></div>
      </div> -->
      <div class="chart-item chart-item-long">
        <div class="chart-item-tit">商品统计图</div>
        <wt-auth class="search-form-btn" :hasAnyPremission="'MODULE_SITESTATISTICS:EXPORT'">
          <el-button class="chart-export chart-export-total" size="small" @click="exportChart('商品统计合计', goodsTotalUrl)">导出合计</el-button>
          <el-button class="chart-export" size="small" @click="exportChart('商品统计', goodsUrl)">导出</el-button>
        </wt-auth>
        <div class="chart-item-canvas" id="sasgoodsChart"></div>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from './mixin.js'
export default {
  name: 'StatisticalAnalysisSate',
  mixins: [mixin],
  data() {
    return {
      form: {
        dataTimeRange: [],
        communityId: '',
        orgId1: '',
        orgId2: '',
        orgId3: '',
        siteId: '',
        siteIdList: []
      },
      communityOptions: [],
      props: { children: 'childList', label: 'name', value: 'id', expandTrigger: 'hover', multiple: true, emitPath: false },
      siteOptions: [],
      recyclingUrl: '/modules/statisticalSite/garbageStatisticalImport1', // '/modules/statisticalSite/garbageStatisticalImport',
      recyclingTotalUrl: '/modules/statisticalSite/garbageStatisticalImport1All',
      otherUrl: '/modules/statisticalSite/otherStatisticalImport2', // '/modules/statisticalSite/otherStatisticalImport',
      otherTotalUrl: '/modules/statisticalSite/otherStatisticalImport2All',
      goodsUrl: '/modules/statisticalSite/goodsStatisticalImport3', // '/modules/statisticalSite/goodsStatisticalImport',
      goodsTotalUrl: '/modules/statisticalSite/goodsStatisticalImport3All',
      chartEle: {
        recyclingChart: null,
        consumablesChart: null,
        SHApplianceChart: null,
        goodsChart: null
      }
    }
  },
  created() {
    this.initCreated()
  },
  mounted() {
    const that = this
    window.addEventListener('resize', that.resizeView)
    this.initPage()
  },
  beforeDestroy() {
    const that = this
    window.removeEventListener('resize', that.resizeView)
  },
  methods: {
    initCreated() {
      this.orgTreeList()
    },
    // 初始化页面
    initPage() {
      // this.consumablesStatistical()
      this.garbageStatistical()
      this.goodsStatistical()
      this.otherStatistical()
    },
    toClickAction(type) {
      if (type === 'reset') {
        this.form = {
          dataTimeRange: [],
          communityId: '',
          orgId1: '',
          orgId2: '',
          orgId3: '',
          siteId: '',
          siteIdList: []
        }
        // this.communityIdChange()
      }
      this.initPage()
    },
    communityIdChange() {
      this.form.siteId = ''
      if (this.form.communityId) {
        this.$store.dispatch('querySiteListNoPageList', this.form.communityId).then(res => {
          this.siteOptions = res
        })
      } else {
        this.siteOptions = []
      }
    },
    exportChart(name, url) {
      const that = this
      const timer = (new Date()).getTime()
      const fileName = '社区站点' + (name || '工单') + timer + '.xlsx'
      this.$wtUtil.downloadFile({
        url: window.wtConst.BASE_API + url,
        data: this.getReqParams(), // this.form,
        fileName: fileName
      }).then((res) => {
        console.log('导出成功')
      }).catch((err) => {
        that.$message({ message: err, type: 'error' })
      })
    },
    // 耗材统计
    consumablesStatistical() {
      this.$api.statistical.site.consumablesStatistical(this.getReqParams()).then(res => {
        this.$nextTick(() => {
          this.initConsumables(this.transResData(res.data, 1))
        })
      })
    },
    // 可回收物投递出库统计
    garbageStatistical() {
      this.$api.statistical.site.garbageStatistical(this.getReqParams()).then(res => {
        this.$nextTick(() => {
          this.initRecycling(this.transResData(res.data, 2))
        })
      })
    },
    // 商品统计
    goodsStatistical() {
      this.$api.statistical.site.goodsStatistical(this.getReqParams()).then(res => {
        this.$nextTick(() => {
          this.initGoods(this.transResData(res.data, 2))
        })
      })
    },
    // 其他类型统计
    otherStatistical() {
      this.$api.statistical.site.otherStatistical(this.getReqParams()).then(res => {
        this.$nextTick(() => {
          this.initSmallHomeAppliance(this.transResData(res.data, 1))
        })
      })
    },
    getReqParams() {
      return {
        dataTimeRange: this.form.dataTimeRange,
        communityId: '',
        siteIdList: this.form.siteIdList,
        orgId1: '', // this.form.siteId.length === 1 ? this.form.siteId.slice(-1)[0] : '',
        orgId2: '', // this.form.siteId.length === 2 ? this.form.siteId.slice(-1)[0] : '',
        orgId3: ''// this.form.siteId.length === 3 ? this.form.siteId.slice(-1)[0] : '',
        // siteId: this.form.siteId.length === 4 ? this.form.siteId.slice(-1)[0] : ''
      }
    },
    // 可回收物投递出库图
    initRecycling(data) {
      this.chartEle.recyclingChart = this.$echarts.init(document.getElementById('sasRecyclingChart'))
      this.chartEle.recyclingChart.setOption(this.createOption({
        legend: { top: '0', data: ['投递数', '出库数'] },
        chartName: '社区站点统计-可回收物投递出库图',
        xNames: data.xNames,
        series: [
          {
            name: '投递数',
            type: 'bar',
            data: data.y1Names
          },
          {
            name: '出库数',
            type: 'bar',
            data: data.y2Names
          }
        ]
      }))
    },
    // 其他类型统计图
    initSmallHomeAppliance(data) {
      this.chartEle.SHApplianceChart = this.$echarts.init(document.getElementById('sasSHApplianceChart'))
      this.chartEle.SHApplianceChart.setOption(this.createOption({
        color: ['#94bfff'],
        chartName: '社区站点统计-其他类型统计图',
        xNames: data.xNames,
        series: [
          {
            name: '',
            type: 'bar',
            barMaxWidth: 60,
            data: data.y1Names
          }
        ]
      }))
    },
    // 耗材统计图
    initConsumables(data) {
      this.chartEle.consumablesChart = this.$echarts.init(document.getElementById('sasConsumablesChart'))
      this.chartEle.consumablesChart.setOption(this.createOption({
        chartName: '社区站点统计-耗材统计图',
        xNames: data.xNames,
        series: [
          {
            name: '',
            type: 'bar',
            barMaxWidth: 60,
            data: data.y1Names
          }
        ]
      }))
    },
    // 商品统计图
    initGoods(data) {
      this.chartEle.goodsChart = this.$echarts.init(document.getElementById('sasgoodsChart'))
      this.chartEle.goodsChart.setOption(this.createOption({
        legend: { top: '0', data: ['配送数', '兑换数'] },
        color: ['#fa9a94', '#832a33'],
        chartName: '社区站点统计-商品统计图',
        xNames: data.xNames,
        series: [
          {
            name: '配送数',
            type: 'bar',
            data: data.y1Names
          },
          {
            name: '兑换数',
            type: 'bar',
            data: data.y2Names
          }
        ]
      }))
    },
    // 重绘
    resizeView() {
      for (const key in this.chartEle) {
        if (this.chartEle[key]) {
          this.chartEle[key].resize()
        }
      }
    },
    // 站点
    orgTreeList() {
      this.$api.siteManage.org.orgTreeList().then(res => {
        this.$wtUtil.setSiteLevelKey(res.data)
        this.siteOptions = res.data
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .chart-container .chart-item .chart-export.chart-export-total {
    right: 86px;
  }
</style>
